import { API_URL } from "config";
import Http from "util/https";
import { CompanySearchApiParams, CompanyStockList, CompanyResponseApi, AmountHiddenSymbol, AmountAPISymbol } from "../types/index";
import { convertSymbolAPItoClient, convertUTCToDateTimeMinutes, nullToBlank, nullToZero } from "../utils/common";

const splitSetStr = ',';

/**
 * 企業用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns CompanyStockList
 */
export default async function companyStockListApi(params: CompanySearchApiParams) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/stock/select/company`;
  const res = await http.post<CompanyResponseApi>(url, params);

  const stockList: CompanyStockList = {
    total: res.data.total,
    companyUpdated: convertUTCToDateTimeMinutes(res.data.shop_updated),
    storehouseUpdated: convertUTCToDateTimeMinutes(res.data.depot_updated),
    stocks: res.data.stocks.map((s, i) => {
      if (s.item_code.length === 6) {
        return {
          id: `${i + (params.offset ?? 0)}`,
          JANCd: s.jan_cd,
          productNumber: s.item_num,
          productName: s.item_name ?? '',
          brand: s.brand_name ?? '',
          productCd: s.item_code,
          size: s.size ?? '',
          classification: s.class_name,
          storeAmountList: s.store_quantities.map((q, idx) => {
            const vendorShopQuantity = s.vendor_quantities.filter(v => v.store_cd === q.store_cd)[0];
            const stagnantStock = s.is_stagnant_stocks.filter(is_ss => is_ss.store_cd === q.store_cd)[0];
            let neighborAmount: number | AmountHiddenSymbol = '×';
            let centerAmount: number | AmountHiddenSymbol = '×';
            if (vendorShopQuantity) {
              const nearNotNull = nullToBlank(vendorShopQuantity.nearby_quantity, '-');
              const centerNotNull = nullToBlank(vendorShopQuantity.centor_quantity, '-');
              neighborAmount = Number.isNaN(Number(nearNotNull)) ? convertSymbolAPItoClient(nearNotNull as AmountAPISymbol) : Number(nearNotNull);
              centerAmount = Number.isNaN(Number(centerNotNull)) ? convertSymbolAPItoClient(centerNotNull as AmountAPISymbol) : Number(centerNotNull);
            }
            return {
              storeCd: q.store_cd,
              storeAmount: nullToZero(q.quantity),
              neighborAmount,
              centerAmount,
              isStagnantStock: stagnantStock ? stagnantStock.is_stagnant_stock : false,
            }
          }),
          tyreStorehouse: s.depot_quantity,
          supplierName: s.vendor_name,
          arrivalDate: s.vendor_arrival_date,
          updateTime: convertUTCToDateTimeMinutes(s.vendor_updated_at),
          isDiscontinued: s.discontinued_flag,
        }
      }
      return {
        id: `${i + (params.offset ?? 0)}`,
        JANCd: s.jan_cd,
        productNumber: s.item_num,
        productName: s.item_name ?? '',
        productSetCd: s.item_code,
        classification: "タイヤ・ホイール",
        stockSingleList: [{
          // タイヤ
          productCd: s.item_code.slice(0, 6),
          productName: s.item_name ? s.item_name.split(splitSetStr)[0] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[0] : '',
          size: s.size ? s.size.split(splitSetStr)[0] : '',
          quantity: 1
        }, {
          // ホイール
          productCd: s.item_code.slice(6, 12),
          productName: s.item_name ? s.item_name.split(splitSetStr)[1] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[1] : '',
          size: s.size ? s.size.split(splitSetStr)[1] : '',
          quantity: 1
        }],
        storeAmountList: s.store_quantities.map((q, idx) => {
          const stagnantStock = s.is_stagnant_stocks.filter(is_ss => is_ss.store_cd === q.store_cd)[0];
          return {
            storeCd: q.store_cd,
            storeAmount: q.quantity,
            isStagnantStock: stagnantStock ? stagnantStock.is_stagnant_stock : false,
          }
        }),
        tyreStorehouse: s.depot_quantity,
        isDiscontinued: s.discontinued_flag,
      }
    }),
  };

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  // return res.data;
  return stockList;
}
